import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'

import PromoItem from '../components/Promo-Item'

const Hero = () => (

	<svg x="0px" y="0px" viewBox="0 0 204 81" className="Logo--logo"><g><g><path className="Logo--black" d="M57.715,80.628H36.174V49.859H22.192v30.769H0.079L0,1.327h22.192v29.499h13.982V1.327h21.541V80.628z M156.412,81c22.212-0.009,40.287-18.464,40.282-40.679C196.69,17.637,178.624,0.017,156.412,0 c-22.186-0.016-33.522,16.315-36.323,22.907c0.026-9.895-9.727-21.576-21.136-21.588H62.197V80.6l34.269,0.012 c13.817,0,23.648-11.972,23.666-22.238C123.286,64.835,134.226,81.008,156.412,81z M93.595,48.741 c3.171,0,5.669,3.132,5.669,6.699c0,3.568-2.498,6.699-5.669,6.699h-10.9V48.741H93.595z M93.635,18.971 c3.171,0,5.669,3.131,5.669,6.699c0,3.568-2.498,6.7-5.669,6.7H82.734V18.971H93.635z M108.143,40.337 c2.497-0.317,6.66-3.171,8.127-4.995c-0.516,2.26-0.555,8.8,0.047,11.06C114.644,43.826,110.68,40.654,108.143,40.337z M136.244,40.337c0-11.146,9.035-20.182,20.181-20.182c11.146,0,20.182,9.036,20.182,20.182c0,11.147-9.036,20.182-20.182,20.182 C145.279,60.519,136.244,51.484,136.244,40.337z M156.425,56.202c8.762,0,15.865-7.102,15.865-15.865 c0-8.762-7.103-15.865-15.865-15.865c-8.762,0-15.865,7.103-15.865,15.865C140.56,49.1,147.663,56.202,156.425,56.202z"></path></g><path className="Logo--black" d="M197.694,2.578c1.501,0,2.782,0.53,3.842,1.589c1.054,1.054,1.582,2.326,1.582,3.818 c0,1.503-0.527,2.784-1.582,3.843c-1.054,1.059-2.335,1.589-3.842,1.589c-1.507,0-2.788-0.529-3.842-1.589 c-1.049-1.059-1.573-2.34-1.573-3.843c0-1.491,0.527-2.764,1.582-3.818C194.92,3.108,196.198,2.578,197.694,2.578z M203.967,7.976 c0-1.729-0.613-3.203-1.838-4.421c-1.225-1.218-2.707-1.827-4.444-1.827c-1.727,0-3.199,0.609-4.419,1.827 c-1.225,1.223-1.838,2.697-1.838,4.421c0,1.741,0.607,3.224,1.821,4.447c1.219,1.23,2.698,1.844,4.436,1.844 c1.738,0,3.219-0.614,4.444-1.844C203.354,11.194,203.967,9.711,203.967,7.976z M199.353,6.618c0,0.522-0.24,0.876-0.721,1.061 c-0.261,0.102-0.652,0.152-1.173,0.152h-1.112V5.371h1.051c0.683,0,1.18,0.084,1.489,0.253 C199.198,5.792,199.353,6.123,199.353,6.618z M195.163,4.521v6.861h1.184V8.68h0.973c0.654,0,1.111,0.074,1.372,0.221 c0.44,0.255,0.66,0.779,0.66,1.572v0.544l0.025,0.221c0.006,0.028,0.011,0.054,0.017,0.077c0.006,0.023,0.011,0.045,0.017,0.068 h1.125l-0.043-0.085c-0.029-0.057-0.05-0.176-0.061-0.358c-0.011-0.181-0.017-0.352-0.017-0.51V9.927 c0-0.346-0.125-0.7-0.373-1.063c-0.249-0.363-0.642-0.587-1.179-0.673c0.427-0.068,0.76-0.178,0.999-0.332 c0.45-0.289,0.675-0.74,0.675-1.354c0-0.862-0.357-1.442-1.071-1.737c-0.4-0.165-1.029-0.247-1.886-0.247H195.163z"></path></g></svg>

)

const IndexPage = props => (
	
	<div className="homepage">
	
		<Hero/>
		
		<ul className="homepage--promos clearfix">
		
		  <PromoItem headline="Discover<br/>Our Programming" title="Discover Our Programming on hbo.co.uk" ctaText="Explore Now" ctaLink="https://hbo.co.uk" promoImage={props.data.promoOne} />
		  
		  <PromoItem headline="DVDs<br/>On Amazon" title="DVDs on Amazon" ctaText="Shop Now" ctaLink="https://www.amazon.co.uk/stores/page/BCB4D546-A59B-4F3E-BAD4-72E23F1E6E47?ingress=3" promoImage={props.data.promoTwo}/>

      <PromoItem headline="Visit the<br/>Touring Exhibition" title="Visit the Touring Exhibition" ctaText="Explore Now" ctaLink="http://gameofthronesexhibition.com" promoImage={props.data.promoThree}/>
      
      <PromoItem headline="Game of Thrones Live<br/>Concert Experience" title="Game of Thrones Live Concert Experience" ctaText="See Dates & Locations" ctaLink="https://www.gameofthronesconcert.com" promoImage={props.data.promoFour}/>
		
		</ul>
	
	</div>
	
)

export default IndexPage


export const pageQuery = graphql`
  query PromoImageOneQuery {
    promoOne: imageSharp(id: { regex: "/promo-1/" }) {
      sizes(maxWidth: 594 ) {
        ...GatsbyImageSharpSizes
      }
    },
    promoTwo: imageSharp(id: { regex: "/promo-2/" }) {
      sizes(maxWidth: 594 ) {
        ...GatsbyImageSharpSizes
      }
    },
    promoThree: imageSharp(id: { regex: "/promo-3/" }) {
      sizes(maxWidth: 594 ) {
        ...GatsbyImageSharpSizes
      }
    },
    promoFour: imageSharp(id: { regex: "/promo-4/" }) {
      sizes(maxWidth: 594 ) {
        ...GatsbyImageSharpSizes
      }
    }
  }`


// WEBPACK FOOTER //
// ./src/pages/index.js